import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiButton } from '@elastic/eui';
import NavButtons from 'components/Downloads/Indoor_Cameras/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "IN-8003 Full HD Downloads",
  "path": "/Downloads/Indoor_Cameras/IN-8003_HD/",
  "dateChanged": "2017-12-12",
  "author": "Mike Polinowski",
  "excerpt": "INSTAR Firmware, WebUI and Documentation Downloads",
  "image": "./D_SearchThumb_8003.png",
  "social": "/images/Search/D_SearchThumb_Indoor_Cameras.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-Downloads_white.webp",
  "chapter": "Downloads"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Download Area - IN-8003 Full HD' dateChanged='2018-09-20' author='Mike Polinowski' tag='INSTAR IP Camera' description='Software Downloads and Usermanuals for your INSTAR Products' image='/images/Search/P_SearchThumb_IN-8003HD_Downloads.png' twitter='/images/Search/P_SearchThumb_IN-8003HD_Downloads.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationEN={props.location.pathname} locationDE='/de/Downloads/Innenkameras/IN-8003_HD/' locationFR='/fr/Downloads/Indoor_Cameras/IN-8003_HD/' crumbLabel="IN-8003" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h1 {...{
      "id": "downloads",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#downloads",
        "aria-label": "downloads permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Downloads`}</h1>
    <h2 {...{
      "id": "indoor-cameras",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#indoor-cameras",
        "aria-label": "indoor cameras permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Indoor Cameras`}</h2>
    <h2 {...{
      "id": "in-8003-full-hd-downloads",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#in-8003-full-hd-downloads",
        "aria-label": "in 8003 full hd downloads permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IN-8003 Full HD Downloads`}</h2>
    {/* TOC */}
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#software-installation-wizard"
        }}>{`Software Installation Wizard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#instructions"
        }}>{`Instructions`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#quick-installation"
            }}>{`Quick Installation`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#camera-software-updates"
        }}>{`Camera software updates`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#firmware"
            }}>{`Firmware`}</a>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#download"
                }}>{`Download`}</a></li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    {/* /TOC */}
    <h2 {...{
      "id": "software-installation-wizard",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#software-installation-wizard",
        "aria-label": "software installation wizard permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Software Installation Wizard`}</h2>
    <p>{`Every INSTAR product comes with an installation CD. The CD contains an installation assistant that guides you through the installation of your new INSTAR product. The installation wizard can also be called directly by clicking on the link below and opening the CD online. The wizard contains all the information and current download links you need for the installation.`}</p>
    <p>{`The software CD includes an HTML setup wizard that guides you through the required settings and displays the current download links for your INSTAR product.`}</p>
    <p><strong parentName="p">{`Quick Installation Wizard`}</strong>{`: The wizard guides you through the most important steps to get your INSTAR product up and running.`}</p>
    <p><strong parentName="p">{`Software Installation`}</strong>{`: You will find download links if your INSTAR product requires additional software. You are guided through all steps after you have completed the download and the installation.`}</p>
    <p><strong parentName="p">{`Firmware Updates`}</strong>{`: INSTAR provides firmware and WebUI updates for its products at regular intervals. Below you will find the latest versions of the firmware and WebUI which you can upload to your INSTAR camera.`}</p>
    <OutboundLink href="https://install.instar.com/" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink"><EuiButton fill mdxType="EuiButton">Start Installation</EuiButton></OutboundLink>
    <h2 {...{
      "id": "instructions",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#instructions",
        "aria-label": "instructions permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Instructions`}</h2>
    <h3 {...{
      "id": "quick-installation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#quick-installation",
        "aria-label": "quick installation permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Quick Installation`}</h3>
    <p>{`The flyer contains the most important information about your INSTAR camera.`}</p>
    <Link to="https://wiki.instar.com/dl/IN-8003HD/QuickInstallation-1080p-IN-8003HD.pdf" target="_blank" rel="noopener noreferrer" mdxType="Link"><EuiButton fill mdxType="EuiButton">Quick Start Guide</EuiButton></Link>
    <h2 {...{
      "id": "camera-software-updates",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#camera-software-updates",
        "aria-label": "camera software updates permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Camera software updates`}</h2>
    <h3 {...{
      "id": "firmware",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#firmware",
        "aria-label": "firmware permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Firmware`}</h3>
    <p>{`You will always find here the latest version and all previous versions of the firmware for your INSTAR Camera. If you plan to update the WebUI, make sure that you have installed the latest version of the firmware. In most cases, the new features in the web interface (WebUI) also require the latest firmware. For information on how to update the firmware please look `}<a parentName="p" {...{
        "href": "/en/Quick_Installation/WebUI_And_Firmware_Upgrade/"
      }}>{`Here`}</a>{`.`}</p>
    <p><strong parentName="p">{`Important`}</strong>{`: Unzip the * .ZIP file after downloading. Please note that you must first install the latest firmware and then the WebUI.`}</p>
    <h4 {...{
      "id": "download",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#download",
        "aria-label": "download permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Download`}</h4>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.3.%28378%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.3 (378)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`TLS certificate renewed`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.3.%28377%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.3 (377)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`Removed SSL 3.0: Due to its vulnerabilities and deprecation by industry standards, SSL 3.0 support has been completely removed`}</li>
          <li parentName="ul">{`Disabled Insecure Ciphers: All ciphers considered insecure have been disabled`}</li>
          <li parentName="ul">{`These changes ensures compliance with modern security protocols and best practices to enhance security`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.3.%28374%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.3 (374)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`An issue has been resolved where folders could no longer be created via FTP`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.3.%28373%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.3 (373)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`TLS certificate renewed`}</li>
          <li parentName="ul">{`MQTT alarm server: Automatically goes back to idle state after being triggered`}</li>
          <li parentName="ul">{`General bug fixes and improvements`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003_FW_4.1.2.48_WebUI_3.3.%28372%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.3 (372)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`TLS certificate renewed`}</li>
          <li parentName="ul">{`General bug fixes and improvements`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003_FW_4.1.2.48_WebUI_3.3.%28371%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.3 (371)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`HomeKit reliability has been improved`}</li>
          <li parentName="ul">{`General bug fixes and improvements`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.3.%28370%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.3 (370)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`Elastic Search replaces the previous INSTAR Wiki Search`}</li>
          <li parentName="ul">{`The MQTT alarm server status is reset automatically.`}</li>
          <li parentName="ul">{`A problem with the FritzBox was solved, where one was pointed to a new unknown device.`}</li>
          <li parentName="ul">{`The HTTPS certificate was updated`}</li>
          <li parentName="ul">{`The WebUI is no longer loaded in the iFrame`}</li>
          <li parentName="ul">{`General bug fixes and improvements`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.2.%28366%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.2 (366)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`HomeKit Support - Add your camera to Apple's HomeKit app!`}</li>
          <li parentName="ul">{`Activate / deactivate the license and face detection of the Cloud in the camera's WebUI. Note: These features are only available if your cloud storage plan includes either of these options.`}</li>
          <li parentName="ul">{`The text-heavy Installation Wizard has been cleaned up and updated.`}</li>
          <li parentName="ul">{`General bug fixes and improvements`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003_FW_4.1.2.48_WebUI_3.2.%28364%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.2 (364)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`Support of the Apple Homekit service`}</li>
          <li parentName="ul">{`Enable / disable Cloud License Plate or Face Capture via the Cloud menu of the camera webUI. Note: License plate or face capture must be present in your Cloud storage plan.`}</li>
          <li parentName="ul">{`The text-heavy setup wizard has been cleaned up and updated.`}</li>
          <li parentName="ul">{`Both the backup alarm schedule and the regular alarm schedule are now switchable via MQTT.`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.1.(350)_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.1 (350)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`Alexa Support - The INSTAR Cloud Skill, which allows you to view live video from your camera as well as recordings in the cloud, is now available.`}</li>
          <li parentName="ul">{`IFTTT Support - On the IFTTT platform we provide our service called INSTAR. The INSTAR applets offer you the possibility to control some settings of your INSTAR camera or INSTAR Cloud with IFTTT.`}</li>
          <li parentName="ul">{`A free INSTAR Cloud account is required to use Alexa and IFTTT. If you sign up now, you can also test the chargeable range of functions, such as the storage of alarm videos, for 30 days free of charge.`}</li>
          <li parentName="ul">{`With Alexa and IFTTT, the new menu category Smarthome was introduced. The alarm server and MQTT settings can now be found under Smarthome.`}</li>
          <li parentName="ul">{`MQTT topic prefix and client ID definable`}</li>
          <li parentName="ul">{`General bug fixes and improvements`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.0.(328)_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.0`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`Audio support for the Safari Browser (HTML5 video stream)`}</li>
          <li parentName="ul">{`Fullscreen view for HTML5 and MJPEG streams by double clicking or quick control button`}</li>
          <li parentName="ul">{`HTML5 audio stream can be muted with quick control button`}</li>
          <li parentName="ul">{`Timed IR control has been linked with the IR-Cut mode`}</li>
          <li parentName="ul">{`Timer plan for WDR mode is now available`}</li>
          <li parentName="ul">{`Timed settings now have priority and will be applied if the current time matches`}</li>
          <li parentName="ul">{`The SD card viewer has been reworked. Multiple files can now be downloaded at once.`}</li>
          <li parentName="ul">{`Alarm menu has been reorganized`}</li>
          <li parentName="ul">{`You can now change the recording resolution in the alarm menu`}</li>
          <li parentName="ul">{`Going forward, notification Pop-ups are resetted after each update`}</li>
          <li parentName="ul">{`General bug fixes and improvements`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_2.6.(320)_update.zip"
          }}>{`FW 4.1.2.48 WebUI 2.6`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`HTML5 video stream support for the new Edge (Chrome), Google Chrome, Mozilla Firefox and Safari Browser`}</li>
          <li parentName="ul">{`Video settings have been reworked`}</li>
          <li parentName="ul">{`SSL certificate has been updated for HTTPS and MQTT.`}</li>
          <li parentName="ul">{`If the integrated certificate is being used, all MQTT clients connected to this MQTT broker require the new host certificate.`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.47_WebUI_2.5.(308)_update.zip"
          }}>{`PoE FW 4.1.2.47 WebUI 2.5`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`PTZ functionality completely revised IN-9010FullHD / IN-9020FullHD`}</li>
          <li parentName="ul">{`It is recommended to perform a PTZ reset! IN-9010FullHD / IN-9020FullHD`}</li>
          <li parentName="ul">{`Alarm suppression during PTZ available IN-9010FullHD / IN-9020FullHD`}</li>
          <li parentName="ul">{`PTZ reset button available in PTZ menu`}</li>
          <li parentName="ul">{`Simplified Cloud Integration`}</li>
          <li parentName="ul">{`From now on you have to enter the login data (email address and cloud password) of your cloud account instead of the camera cloud data as before.`}</li>
          <li parentName="ul">{`Extended alarm server functionalities`}</li>
          <li parentName="ul">{`Alarm activation/deactivation via DeepL Access button`}</li>
          <li parentName="ul">{`Changing the alarm video length no longer causes a restart`}</li>
          <li parentName="ul">{`General bugfixes and improvements`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.47_WebUI_2.5.(288)_update.zip"
          }}>{`FW 4.1.2.47 WebUI 2.5`}</a>{` `}{`[SHA265: `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`4d00df34f72d15b25e7682bbe2e714e522672893c636e8226e5d6b718a4eab36`}</code>{`]`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Native smarthome support with the INSTAR MQTT Broker / Client (ioBroker, OpenHAB, Home Assistant, FHEM, Node-RED and many more...)`}</li>
          <li parentName="ul">{`Set a preferred BSSID in the WiFi configuration`}</li>
          <li parentName="ul">{`A problem with the RTSP stream with the Synology Surveillance Station has been fixed`}</li>
          <li parentName="ul">{`Cool-down interval between requests to the alarm server and  push notification is now configurable`}</li>
          <li parentName="ul">{`Test function for alarm server and push notification now available`}</li>
          <li parentName="ul">{`Custom schedules can be saved as presets`}</li>
          <li parentName="ul">{`WebUI can be added to the home screen of your smartphone (PWA)`}</li>
          <li parentName="ul">{`General bug fixes and layout changes`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.46_WebUI_2.4.(262)_update.zip"
          }}>{`FW 4.1.2.46 WebUI 2.4`}</a>{` `}{`[SHA265: `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`ae375b334ab754f1537aafc8756665a8ba61212090c4ef2cae2d9b00d2ba2fb0`}</code>{`]`}</p>
        <ul parentName="li">
          <li parentName="ul">{`PTZ functionalities have been reworked `}{`[IN-9010FullHD / IN-9020FullHD]`}</li>
          <li parentName="ul">{`A PTZ reset is strongly recommended! `}{`[IN-9010FullHD / IN-9020FullHD]`}</li>
          <li parentName="ul">{`Alarm prevention during PTZ available `}{`[IN-9010FullHD / IN-9020FullHD]`}</li>
          <li parentName="ul">{`PTZ reset button can be found in the PTZ settings`}</li>
          <li parentName="ul">{`Simplified cloud integration`}</li>
          <li parentName="ul">{`From now on it is required to use your Cloud Login data (email address & cloud password) instead of the individual cloud camera data.`}</li>
          <li parentName="ul">{`Extended alarm server functions`}</li>
          <li parentName="ul">{`Arming and disarming the alarm via quick access button`}</li>
          <li parentName="ul">{`Changing the recording length doesn't require a reboot anymore`}</li>
          <li parentName="ul">{`General bug fixes and improvements`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.43_WebUI_2.3.(242)_update.zip"
          }}>{`PoE FW 4.1.2.43 WebUI 2.3 *`}</a>{` `}{`[SHA265: `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`a2121e56b5f9387bda1ae365a8e05fb8f652f3fe600a9749b63ea2e3bbc0b651`}</code>{`]`}{` **`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Support of custom SSL certificates for HTTPS connection with a custom DDNS address`}</li>
          <li parentName="ul">{`Simple 1-Click update method`}</li>
          <li parentName="ul">{`Offline update with traditional PKG file is optionally available`}</li>
          <li parentName="ul">{`Alarm recordings up to 60 seconds`}</li>
          <li parentName="ul">{`Initial network integration via direct WiFi connection - This feature is available for WiFi cameras during initial setup or after a factory reset. After the network integration, the camera’s hotspot will be permanently disabled.`}</li>
          <li parentName="ul">{`An issue with hidden WiFi SSIDs has been solved`}</li>
          <li parentName="ul">{`IR-CUT Filter settings available`}</li>
          <li parentName="ul">{`Weather Widget has been removed * 1`}</li>
          <li parentName="ul">{`Factory reset and WPS activation via SD card has been simplified * 2`}</li>
          <li parentName="ul">{`General bugfixes and layout changes`}</li>
        </ul>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`1 The weather service of Yahoo Weather has been discontinued in its previous form. This feature will be reintroduced to the cameras WebUI at a later point.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`2 Reset and WPS via SD card can now be triggered by a file with the text file extension .txt - For a reset, simply create an empty file in the root folder of you sd card with the name “reset” or “reset.txt” - For WPS activation the file must be named “wps” or “wps.txt”`}</p>
          </li>
        </ul>
      </li>
    </ul>
    <div className="warningbox">
 (*) This version may only be installed on a 8015 Power-over-Ethernet and is not on a 8003 WLAN.
    </div>
    <br /><br />
    <p><em parentName="p">{`** `}<a parentName="em" {...{
          "href": "/en/Downloads/Security/"
        }}>{`What is a SHA256 Hash ?`}</a></em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      